import { skipToken } from '@apollo/client/react'
import { useAtomValue } from 'jotai'
import { localeAtom } from '~/stores/locale'
import { GetWorkflowForMarketByWorkflowIdDocument } from './generated/graphql'
import { createQueryHook, modifyQueryHook } from './utils'

const _useGetWorkflowForMarketByWorkflowId = modifyQueryHook(
  createQueryHook(GetWorkflowForMarketByWorkflowIdDocument),
  {
    reduce: r => r?.workflow?.artwork,
  },
)
export const useGetWorkflowForMarketByWorkflowId = (
  variables: Parameters<typeof _useGetWorkflowForMarketByWorkflowId>[0],
  options?: Parameters<typeof _useGetWorkflowForMarketByWorkflowId>[1],
) => {
  const locale = useAtomValue(localeAtom)
  const input =
    variables !== skipToken
      ? {
          ...variables,
          tackLanguage: locale,
        }
      : skipToken
  return _useGetWorkflowForMarketByWorkflowId(input, options)
}
